export default __webpack_public_path__ + "static/media/img7.959a58e4.png";